import UserProfile from "./SalesforceUserLayout"

export default UserProfile
